class InitChat {
    constructor(doc, src, id) {
        this.doc = doc;
        this.src = src;
        this.id = id;

        this.loadImage()
            .then(() => {
                return this.loadScript();
            })
            .then((e) => {
                return this.initChatButtons(e);
            });
    }

    loadImage() {
        return new Promise((resolve, reject) => {
            const image = this.doc.createElement('img');

            image.alt = '';
            image.src = 'https://alandsbanken.liveagent.se/scripts/pix.gif';
            image.addEventListener('load', () => resolve(image), false);
            image.addEventListener('error', () => reject(image), false);

            this.insertNode(image);
        })
    }

    loadScript() {
        return new Promise((resolve, reject) => {
            const script = this.doc.createElement('script');

            script.id = 'la_x2s6df8d';
            script.async = true;
            script.src = this.src;
            script.addEventListener('load', () => resolve(script), false);
            script.addEventListener('error', () => reject(script), false);

            this.insertNode(script);
        })
    }

    insertNode(node) {
        const lastScript = this.doc.scripts[this.doc.scripts.length - 1];
        lastScript.parentElement.insertBefore(node, lastScript.nextSibling);
    }

    initChatButtons(e) {
        const chatButton = LiveAgent.createButton(this.id, e);
        const chatTriggers = this.doc.querySelectorAll('.chat-trigger');

        for (var i = 0; i < chatTriggers.length; i++) {
            chatTriggers[i].addEventListener('click', () => {
                chatButton.onClick();
            });
        }
    }
}

export { InitChat as default}
